import React, { useState } from 'react';
import { FaAndroid, FaDesktop, FaGlobe, FaMobileAlt, FaShoppingCart, FaUserTie } from 'react-icons/fa';
import { MdSettingsApplications } from 'react-icons/md';

import seller_general_setting from '../../../assets/Docs/seller_genaral.png'
import buyer_general_setting from '../../../assets/Docs/buyer_general.png'
import buyer_profile from '../../../assets/AppImages/buyer_profile.png'
import seller_profile from '../../../assets/AppImages/seller_profile.png'
import { TagComponent } from '../Tabs';

const GeneralsSet = () => {


    const [activeTab1, setActiveTab1] = useState('web');
    const [activeTab2, setActiveTab2] = useState('web');

    const [selectedSection, setSelectedSection] = useState("seller");

    const tabs = [
        { id: 'web', label: 'Web App', icon: <FaDesktop /> },
        { id: 'mobile', label: 'Mobile App', icon: <FaMobileAlt />, disabled: true },
    ];


    const renderTabs = (activeState, setActiveState) => (
        <div className="flex flex-col sm:flex-row gap-2 border-b border-[#b9ece6] sm:gap-4 mb-6">
            {tabs.map((tab) => (
                <button
                    key={tab.id}
                    onClick={() => setActiveState(tab.id)}
                    className={`flex items-center justify-center sm:justify-start gap-2 px-4 py-2 rounded-t-md transition-all text-sm w-full sm:w-auto ${activeState === tab.id
                        ? "bg-[#1a9588] text-white shadow"
                        : "bg-[#dbf4f1] text-gray-700 hover:bg-[#b9ece6]"
                        }`}

                >
                    {tab.icon}
                    {tab.label}
                </button>
            ))}
        </div>
    );



    return (
        <div className="bg-white shadow-lg rounded-xl p-6 sm:p-8  mx-auto border border-gray-200" id="top">

            <div className="flex items-center mb-6 border-b pb-4 border-gray-200">
                <MdSettingsApplications className="text-4xl text-theme-logo-color mr-3" />
                <h1 className="text-2xl sm:text-3xl font-bold text-theme-logo-color">General Settings</h1>
            </div>

            <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center mb-8 gap-4">
                <div className="flex flex-wrap gap-3">
                    <TagComponent icon={<FaUserTie />} label="Seller" color="green" />
                    <TagComponent icon={<FaShoppingCart />} label="Buyer" color="green" />
                </div>
                <div className="flex flex-wrap gap-3">
                    <TagComponent icon={<FaGlobe />} label="Web" color="green" />
                    <TagComponent icon={<FaAndroid />} label="Android" color="green" />
                </div>
            </div>


            <div className="p-6 text-start rounded-lg">
                {/* Title Section */}
                <h2 className="text-2xl  text-start">General Settings - Seller</h2>
                <p className="text-gray-400 mt-2">
                    Seller settings are limited to updating their Contact and Shipping details only.
                </p></div>

            <div className='my-5'>
                {renderTabs(activeTab1, setActiveTab1)}
                <div className="rounded-lg p-2 sm:p-4 flex justify-start">

                    {activeTab1 === "web" ? (
                        <img
                            src={seller_general_setting}
                            alt={`view`}
                            className="rounded-xl max-w-full h-auto object-contain"
                        />
                    ) : (
                        <img
                            src={seller_profile}
                            alt={`view`}
                            className="rounded-xl max-w-full h-auto object-contain"
                        />
                    )}


                </div>
            </div>

            <div className="p-6 text-start rounded-lg">
                {/* Title Section */}
                <h2 className="text-2xl  text-start">General Settings - Buyer</h2>
                <p className=" mt-2">
                    ‘Buyer’ settings are limited to updating their Contact and Shipping details only.
                </p></div>

            <div className='my-5'>
                {renderTabs(activeTab2, setActiveTab2)}
                <div className="rounded-lg p-2 sm:p-4 flex justify-start">
                    {activeTab2 === "web" ? (
                        <img
                            src={buyer_general_setting}
                            alt={`view`}
                            className="rounded-xl max-w-full h-auto object-contain"
                        />
                    ) : (
                        <img
                            src={buyer_profile}
                            alt={`view`}
                            className="rounded-xl max-w-full h-auto object-contain"
                        />
                    )}
                </div>
            </div>
        </div>
    );
};

export default GeneralsSet;